/* istanbul ignore file: This is just a wrapper of other, tested code */
import React from "react";
import { ThemeProvider } from "@material-ui/core";
import { ReactQueryConfigProvider, ReactQueryConfig } from "react-query";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { ReactQueryDevtools } from "react-query-devtools";
import DateFnsUtils from "@date-io/date-fns";
import { BrowserRouter as Router } from "react-router-dom";
import { ConfigProvider } from "./features/Auth";
import { theme } from "./theme";
import { GlobalErrorProvider } from "./features/ErrorModal";
import { AuthenticatedUserProvider } from "./features/Auth/UserProvider";
import { BreadcrumbsProvider } from "./components/Breadcrumb";
import { AuthSessionProvider } from "./features/Auth/AuthSessionProvider";
import { PendingMeterReadProvider } from "./hooks";
import { AppHistoryProvider } from "./components/AppHistory";

const reactQueryDefaults: ReactQueryConfig = {
  queries: {
    refetchOnWindowFocus: false,
  },
};
// NOTE: The order of providers matters as some (by design) relies on others.
export const Providers: React.FC = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <ReactQueryConfigProvider config={reactQueryDefaults}>
        <ReactQueryDevtools initialIsOpen={false} />
        <GlobalErrorProvider>
          <AuthSessionProvider>
            <ConfigProvider>
              <Router>
                <AppHistoryProvider>
                  <GlobalErrorProvider>
                    <AuthenticatedUserProvider>
                      <PendingMeterReadProvider store={window.localStorage}>
                        <BreadcrumbsProvider>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            {children}
                          </MuiPickersUtilsProvider>
                        </BreadcrumbsProvider>
                      </PendingMeterReadProvider>
                    </AuthenticatedUserProvider>
                  </GlobalErrorProvider>
                </AppHistoryProvider>
              </Router>
            </ConfigProvider>
          </AuthSessionProvider>
        </GlobalErrorProvider>
      </ReactQueryConfigProvider>
    </ThemeProvider>
  );
};
